module.exports = __webpack_public_path__ + "static/media/tasnuvaResume.faf67952.pdf";